/**
 * @generated SignedSource<<e52c505582ecec24de50ffa1befb2268>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutTrackingActions_buyer$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "checkoutTrackingActions_buyer";
};
export type checkoutTrackingActions_buyer$key = {
  readonly " $data"?: checkoutTrackingActions_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutTrackingActions_buyer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutTrackingActions_buyer"
};

(node as any).hash = "98a0d7af66315fb70c0134f4bddff82a";

export default node;
